import api from "../api";

/**
 * Verify SMS verification code for password reset
 * API #4: POST /app/auth/login-by-sms-verify
 * @param {string} phone - Phone number
 * @param {string} code - 6-digit verification code
 * @returns {Promise<object>} Response data with token on success
 */
const verifySmsCode = async (phone, code) => {
    const requestData = {
        phone: phone,
        code: code,
    };

    try {
        const response = await api.post(
            process.env.REACT_APP_REACT_APP_CD_API_ENDPOINT + "/app/auth/login-by-sms-verify",
            requestData
        );

        if (response.status === 200 || response.status === 201) {
            return response.data;
        } else {
            console.error("SMS verification failed with status:", response.status);
            return null;
        }
    } catch (error) {
        console.error("There was a problem with the SMS verification:", error);
        throw error;
    }
};

export default verifySmsCode;
